export default __webpack_public_path__ + "bdb381621c7441f4b86294d6535d17f9.webp";